import React from "react";
import { Edit } from "react-admin";
import { StoreTabbedForm } from "./StoreTabbedForm";

export const StoreEdit = (props) => (
  <Edit title="Editar Loja" {...props}>
    <StoreTabbedForm {...props} />
  </Edit>
);
